import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { writerStatus } from "../../constants/commonConstants";

const writerAvatarPlaceholder =
  "https://static.vecteezy.com/system/resources/thumbnails/002/002/403/small/man-with-beard-avatar-character-isolated-icon-free-vector.jpg";

const AssignedWriterProfileCard = () => {
  const location = useLocation();
  const thread = useSelector((state) => state.thread);
  const assignedWriter = thread?.selectedOrder?.writer;
  const assignedWriterId = thread?.selectedOrder?.writer?.id;
  const canViewProfile = thread?.selectedOrder?.writer?.status === writerStatus.ACTIVE;
  const selectedRoomId =
    thread?.selectedThreadRoomId || thread?.selectedThread?.roomId;
  const selectedThreadId =
    thread?.selectedThreadId || thread?.selectedThread?._id;
  const returnToThread =
    selectedRoomId && selectedThreadId
      ? `/thread?roomIdParam=${encodeURIComponent(
          selectedRoomId
        )}&threadIdParam=${encodeURIComponent(selectedThreadId)}`
      : null;

  if (!assignedWriterId) {
    return null;
  }

  return (
    <div className="mx-3 sm:mx-[20px] mt-[18px] rounded-[10px] border border-[#dbe4f2] bg-transparent px-3 py-3 font-inter sm:px-4">
      <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-secondary">
        Assigned Writer
      </p>
      <div className="mt-3 flex items-center gap-3">
        <img
          src={assignedWriter?.profilePicture || writerAvatarPlaceholder}
          alt="Assigned writer"
          onError={(event) => {
            event.currentTarget.src = writerAvatarPlaceholder;
          }}
          className="h-10 w-10 shrink-0 rounded-full border border-[#d7e6ff] bg-white object-cover"
        />
        <div className="min-w-0">
          <p className="truncate text-[12px] font-semibold leading-4 text-secondary">
            Writer ID: {assignedWriterId}
          </p>
          {canViewProfile && (
            <Link
              to={`/writer/${assignedWriterId}`}
              state={
                returnToThread
                  ? {
                      returnTo: returnToThread,
                      backRedirect: location.state?.backRedirect,
                    }
                  : undefined
              }
              className="mt-1 inline-flex text-[12px] font-semibold leading-4 text-blue-shades underline"
            >
              View profile
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignedWriterProfileCard;
